import { jsx as _jsx } from "react/jsx-runtime";
import { observer } from "mobx-react";
import { useCallback, useMemo, useRef, useState } from "react";
import { FOLDER_TREE_DATA_DEFAULTS, FOLDER_TREE_TOOLBAR_INITIAL_STATE, Icon, useFolderTreeProvider } from "@devowl-wp/react-folder-tree";
import { AppTreeBody } from "./appTreeBody.js";
import { AppTreeMountProvider } from "../../contexts/appTreeMountContext.js";
import { useStores } from "../../store/rootStore.js";
import { __ } from "../../utils/i18n.js";
import { rmlOpts } from "../../utils/rmlOpts.js";
const EMPTY_TREE_NODES = [];
const AppTree = observer((props)=>{
    const { treeStore } = useStores();
    const { staticTree, tree } = treeStore;
    const callbacksRef = useRef({});
    const [uiBundle, setUiBundle] = useState(()=>({
            headline: /*#__PURE__*/ _jsx("span", {
                style: {
                    paddingRight: 5
                },
                children: __("Folders")
            }),
            creatable: FOLDER_TREE_DATA_DEFAULTS.creatable,
            toolbar: FOLDER_TREE_DATA_DEFAULTS.toolbar,
            multiToolbar: FOLDER_TREE_DATA_DEFAULTS.multiToolbar,
            isBusyHeader: false,
            noFoldersTitle: __("No folders found"),
            noFoldersDescription: __("No folders have been created yet. Just click on the button above to create your first folder."),
            noSearchResult: __("No search results."),
            renameSaveText: /*#__PURE__*/ _jsx(Icon, {
                type: "save"
            }),
            renameAddText: /*#__PURE__*/ _jsx(Icon, {
                type: "save"
            })
        }));
    const handleUiBundleChange = useCallback((bundle)=>{
        setUiBundle((previous)=>previous === bundle ? previous : bundle);
    }, []);
    const [FolderTreeProvider, folderTreeCtx] = useFolderTreeProvider({
        ...FOLDER_TREE_DATA_DEFAULTS,
        ...FOLDER_TREE_TOOLBAR_INITIAL_STATE(),
        ...uiBundle,
        rootId: +rmlOpts.others.rootId,
        allowMultiSelect: true,
        tree: tree.length > 0 ? tree : EMPTY_TREE_NODES,
        staticTree
    }, {}, {}, {
        observeToolbar: false,
        callbacksRef
    });
    const mountShellValue = useMemo(()=>({
            id: props.id,
            attachmentsBrowser: props.attachmentsBrowser,
            isModal: props.isModal ?? false
        }), [
        props.attachmentsBrowser,
        props.id,
        props.isModal
    ]);
    return /*#__PURE__*/ _jsx(FolderTreeProvider, {
        value: folderTreeCtx,
        children: /*#__PURE__*/ _jsx(AppTreeMountProvider, {
            value: mountShellValue,
            children: /*#__PURE__*/ _jsx(AppTreeBody, {
                ...props,
                callbacksRef: callbacksRef,
                onUiBundleChange: handleUiBundleChange
            })
        })
    });
});
export { AppTree };
